import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";

const Navbar = ({ lang, setLang, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const closeMenu = () => setIsOpen(false);

  const toggleLang = () => {
    setLang(lang === "hr" ? "en" : "hr");
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navbar ${scrolled ? "scrolled" : ""} ${isOpen ? "nav-open" : ""}`}
    >
      <div className="nav-container">
        <div className="nav-logo">M + R</div>

        <div className="nav-actions">
          {/* Jezik - vidljiv uvijek */}
          <div className="lang-switcher" onClick={toggleLang}>
            <span className={lang === "hr" ? "active" : ""}>HR</span>
            <span className="divider">|</span>
            <span className={lang === "en" ? "active" : ""}>EN</span>
          </div>

          {/* RSVP - vidljiv uvijek */}
          <Link
            to="rsvp"
            smooth={true}
            duration={800}
            offset={-70}
            className="nav-rsvp-mobile"
            onClick={closeMenu}
          >
            RSVP
          </Link>

          {/* HAMBURGER koji postaje X */}
          <div
            className={`hamburger ${isOpen ? "active" : ""}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>

        {/* LISTA KOJA KLIZI */}
        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <li>
            <Link to="home" smooth={true} duration={500} onClick={closeMenu}>
              {t.navHome}
            </Link>
          </li>
          <li>
            <Link
              to="story"
              smooth={true}
              duration={500}
              offset={-70}
              onClick={closeMenu}
            >
              {t.navStory}
            </Link>
          </li>
          <li>
            <Link
              to="info"
              smooth={true}
              duration={500}
              offset={-70}
              onClick={closeMenu}
            >
              {t.navInfo}
            </Link>
          </li>
          <li>
            <Link
              to="gallery"
              smooth={true}
              duration={500}
              offset={-70}
              onClick={closeMenu}
            >
              {t.navGallery}
            </Link>
          </li>
          <li>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              offset={-70}
              onClick={closeMenu}
            >
              {t.navContact}
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
